module.exports = {
    get: function() {
        return Math.floor(Date.now() / 1000);
    }
};